import React, { Component } from "react";
import { Container, Form, Row, Col, Button, Image } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { BallTriangle } from "react-loader-spinner";
import { QRRenderingProps, QRType } from "@sphereon/ssi-sdk.qr-code-generator";
import agent from "../../../../../agent";
import { IssueStatus, IssueStatusResponse } from "@sphereon/oid4vci-common";
import { IOID4VCIClientCreateOfferUriResponse } from "@sphereon/ssi-sdk.oid4vci-issuer-rest-client";
import { IPayloadProps, PayloadSubjectUtils } from "./IPayloadProps";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import QRCode from "react-qr-code";
import DeepLink from "./../../../../../components/DeepLink";

const short = require("short-uuid");

export interface PaymentQRState {
  uri?: string;
  preAuthCode?: string;
  qrCode?: JSX.Element;
  qrData?: any;
  credentialPaymentIssued?: boolean;
  paymentProcessed?: boolean;
  paymentProcessing?: boolean;
  displayQRCode?: boolean;
  qrUrl?: string;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default class PaymentStep extends Component<
  IPayloadProps,
  PaymentQRState
> {
  // subjects = new PayloadSubjectUtils();
  paymentTitle = "Please select a payment method:";
  paymentSubtitle = "Please process the following invoice.";
  insuranceTitle = "Thank your for your payment!";
  renderingProps: QRRenderingProps = {
    bgColor: "#FBFBFB",
    fgColor: "black",
    level: "L",
    size: 330,
  };

  agentbaseUrl = process.env.REACT_APP_BACKEND_BASE_URI;
  everifinUrl = process.env.REACT_APP_EVERIFIN_BASE_URI;

  getVCRequestUrl = async (credType: any, params: any, returnOnly: boolean, initiatePayment:boolean = true) =>  {
        
    let response = await fetch(this.agentbaseUrl + "/webapp/definitions/" + credType + "/auth-requests", {
        method: "POST",
        mode: 'cors',
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json"
        }
      });
      let responseJson = await response.json();
      
      let qrUri = "";
      if (params){
        qrUri = responseJson.authRequestURI + "%3Fmerchant%3D"+ params.merchant +"%26amount%3D"+ params.amount +"%26currency%3D" + params.currency;
      } else {
        qrUri = responseJson.authRequestURI;
      }

      this.waitForResponse(responseJson.correlationId, responseJson.definitionId, initiatePayment);   

      if (returnOnly){
        return qrUri;
      }
      this.setState({...this.state, qrUrl: qrUri});

      
 }
waitForResponse = async(correlationId:any, definitionId:any, initiatePayment:boolean = true) => {
    let response = await fetch(this.agentbaseUrl + "/webapp/auth-status", {
        method: "POST",
        mode: 'cors',
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json"
        },
        body: '{"correlationId":"' + correlationId + '","definitionId":"'+ definitionId +'"}'
      });
      let responseJson = await response.json();
      let status = responseJson.status;
      switch(status){
        case "verified":
          if (initiatePayment){
            this.initiatePayment(responseJson.payload, correlationId);
          } else {
            this.setState({...this.state, paymentProcessed: true});
          }
            break;
        default:
            setTimeout(() => this.waitForResponse(correlationId, definitionId, initiatePayment), 2000);
            break;
      }
}

initiatePayment = async(payload:AuthorizationResponsePayload, correlationId: string) => {
  // let accountCredential = this.subjects.getSubjects(payload, 0);
  // let paymentCredential = this.subjects.getSubjects(payload, 1);
  // let authToken = await this.getEverifinAccessToken();

  // let response = await fetch(this.everifinUrl + "/payment", {
  //   method: "POST",
  //   mode: 'cors',
  //   headers: {
  //     Accept: "*/*",
  //     "Content-Type": "application/json",
  //     "x-ef-bank-authorization": authToken, //payload.vp_token,
  //     "x-ef-sender-ip": "10.1.1.1",
  //     "x-ef-sender-user-agent": "NCA SSI Wallet",
  //     "Authorization": "Bearer " + authToken
  //   },
  //   body: '{"instructionId": "' + correlationId + '",' + 
  //         '"redirectUrl": "http://localhost:8080",' +
  //         '"amount": "'+ paymentCredential.amount + '",' + 
  //         '"currency": "'+ paymentCredential.currency + '",' + 
  //         '"recipientIban": "'+ paymentCredential.merchantIBAN + '",' + 
  //         '"recipientName": "'+ paymentCredential.merchantName + '",' + 
  //         '"paymentMessage": "Payment for hotel booking",' +
  //         '"senderIban": "'+ accountCredential.iban + '",' + 
  //         '"senderBankId": "' + accountCredential.swift +  '",' + 
  //         '"startImmediately": "true"}'
  // });
  // let responseJson = await response.json();
  // this.setState({...this.state, paymentProcessing: true});
  // this.waitForPayment(responseJson.data.processablePaymentId, authToken);
}

waitForPayment = async(paymentId:string, authToken:string) => {
  let response = await fetch(this.everifinUrl + "/payment/" + paymentId, {
    method: "GET",
    mode: 'cors',
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json",
      "Authorization": "Bearer " + authToken
    }
  });
  let responseJson = await response.json();
  if (responseJson.meta.status == "SUCCESS" || responseJson.meta.status == "ERROR"){
    this.setState({...this.state, paymentProcessed: true});
    return;
  }
  
  setTimeout(() => this.waitForPayment(paymentId, authToken), 1000);
}

getEverifinAccessToken = async() => {
  let response = await fetch(this.everifinUrl + "/pay-token", {
    method: "POST",
    mode: 'cors',
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json"
    }
  });
  let responseJson = await response.json();
  return responseJson.access_token;
}

  componentDidMount() {
    if (document.location.hash.startsWith("#payment")) {
      //payment processed with open banking API
      console.log("payment succesfully processed");
      this.setState({ ...this.state, paymentProcessed: true });
    }
  }

  generateNewQRCode = async () => {
    const shortUuid = short.generate();
    let merchantIBAN = "SK7002000000004565867451";
    let amount = "145";
    let merchantName = "Luxury Hotel";
    let currency = "EUR";
    let requestUri = await this.getVCRequestUrl("paymenta2a", null, true);
    const uriData: IOID4VCIClientCreateOfferUriResponse =
      await agent.oid4vciClientCreateOfferUri({
        grants: {
          "urn:ietf:params:oauth:grant-type:pre-authorized_code": {
            "pre-authorized_code": shortUuid,
            user_pin_required: false,
          },
        },
        credentialDataSupplierInput: {
          merchantIBAN: merchantIBAN,
          merchantName: merchantName,
          amount: amount,
          currency: currency,
          requestUri: requestUri,
        },
        credentials: ["PaymentInitiation"],
      });

    this.setState({...this.state, qrUrl: uriData.uri});
  };

  componentWillUnmount() {
    this.setState({});
  }

  async processPaymentPSD2() {
    let paymentBody = {
      destinations: [
        {
          accountNumber: "IT60X0542811101000000123456",
          type: "iban",
        },
      ],
      amount: 800,
      currency: "EUR",
      market: "IT",
      recipientName: "Demo Hotel AG",
      sourceMessage: "Payment for hotel booking",
      remittanceInformation: {
        type: "UNSTRUCTURED",
        value: "CREDITOR REFERENCE",
      },
      paymentScheme: "SEPA_CREDIT_TRANSFER",
    };
    let redirectPayment = process.env.REACT_APP_OPEN_BANKING_API_PAY_CONSENT;
    let openBankingRequest = process.env
      .REACT_APP_OPEN_BANKING_API_CAMEL as string;
    console.log(openBankingRequest);
    let response = await fetch(openBankingRequest, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(paymentBody),
    });
    let openBankingDataCamel = await response.json();
    console.log(openBankingDataCamel);
    redirectPayment = redirectPayment?.replace("{id}", openBankingDataCamel.id);
    redirectPayment = redirectPayment?.replace(
      "{redirect-url}",
      encodeURIComponent(window.location.href + "#payment"),
    );
    console.log(redirectPayment);
    if (redirectPayment) {
      window.location.replace(redirectPayment);
    }
    // handle the callback
    return null;
  }

  renderQRCode() {
    if (this.state?.displayQRCode)
      return (
        <div className="qr-code-ssi">
          <div>{this.state?.qrCode}</div>
        </div>
      );
    return null;
  }

  render() {
    if (this.state?.paymentProcessed) {
      return (
        <div style={{ height: "150px" }}>
          <h5>Your payment was succesfully processed!</h5>
          <h3>Thank you!</h3>
        </div>
      );
    } else
      return (
        <div style={{ minHeight: "200px", width: "80%", margin: "auto" }}>
          <h2>{this.paymentTitle}</h2>
          <Container fluid className="justify-content-center align-items-center" style={{marginTop: "30px"}} >
      <Row>
      <Col className="col-lg-6 col-md-6 col-sm-46" >
              <div
                className="pricing-item mb-30"
                style={{
                  border:"2px solid rgb(33, 150, 243)",
                  maxWidth: "300px",
                  float: "right",
                  cursor: "pointer"
                }}
              >
                <Row className="pricing-thumb">
                  <Col className="flex-column justify-content-center align-items-center text-left">
                    <h3 className="title">Your expenses</h3>
                  </Col>
                </Row>
                <div className="pricing-content">
                  <ul className="pricing-list">
                    <li>Minibar - 5 EUR</li>
                    <li>Restaurant - 90 EUR</li>
                    <li>SPA - 50 EUR</li>
                  </ul>
                  <div className="price-wrap">
                    <h3 className="price" style={{color: "rgb(33, 150, 243)"}}>
                      145 EUR<sub></sub>
                    </h3>
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-lg-6 col-md-6 col-sm-6">
          <Accordion >
            <Card>
              <Card.Header style={{textAlign: "left"}}>
                <Image
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAALVBMVEVHcEwApJkBpJkBpJoAo5gBpJkBpJkBpJkApZoBpJkApJkBpJkBpJkApJkBpJm7qk92AAAAD3RSTlMALKtYB8v/2Bbqa3y6PJOVqV5qAAAAnUlEQVR4AWMgBjAqo3Bd0wSQue4oXA7LNC0RBHdnWlpazgUYTzwNBLJhxpalTdr9PC0NKs2aliTAwJMGM80s7QEDR1haLoTHciwVpD0TqpZjWhYD77S0WphJQGXX0jIFkLhhaSFAFlzxtpwGuJuOpTM4LwExEBZBAMIZLMsjEI6cA3RkNqoXcuHKV4I8KIDifeTgYE8TQAs69IAlDAAGlS5Epybm1QAAAABJRU5ErkJggg=="
                  style={{ width: "40px" }}
                ></Image>
                <Accordion.Toggle onClick={() => {
                    this.generateNewQRCode();
                  }} as={Button} variant="link" eventKey="1">
                  Instant Bank transfer
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body style={{textAlign: "left"}}>
                  <h5>
                    <strong>Bank encryption security.</strong>You will need login data for internet banking. Your data is encrypted and you provide it directly to the bank. Everifin is a <strong>licensed payment institution.</strong>
                  </h5>
                  <h5>
                    Please scan the following code with your mobile bank app:
                  </h5>
                  {this.state?.paymentProcessing && !this.state?.paymentProcessed? (
                    <BallTriangle color="#352575" height="100" width="100" />
                  ) : (
                    <div style={{textAlign: "center"}}>
                    {this.state?.qrUrl != null &&  this.state?.qrUrl != "" ? <QRCode className="qr-code-ssi"  value={this.state?.qrUrl ?? ""} /> : null}
                    <QRCode className="qr-code-ssi"  value={this.state?.qrUrl ?? "asdsdafdsfdsafasdas"}></QRCode>
                    </div>
                  )}
                  
                  <br></br></Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
          </Col>
          </Row>
          </Container>
          <br></br>
        </div>
      );
  }
}
